import { logEvent } from "@firebase/analytics";
import { analytics } from "@/firebase_group";

export const FirebaseGroupNewsClick = (newsLabel: string) => {
  logEvent(analytics, "news_click", {
    news_label: newsLabel,
  });
};
